import { css } from '@emotion/react'
import { CobrandedPartnerLogo } from 'components/cobranding/logo/CobrandedPartnerLogo'
import { NavigationDashboard } from 'components/navigation/navigationDashboard/NavigationDashboard'
import { HStack, Stack } from 'components/Stack'
import { Text } from 'components/Typography'
import { Trans, useTranslation } from 'next-i18next'
import Link from 'next/link'
import { cobrandingLogic } from 'utils/cobranding/logic'
import { LogoOfTheDay } from 'utils/cobranding/LogoOfTheDay'
import {
  ProfileSidebarLink,
  SLogoAnchor,
  SLogoDivider,
  SProfileSidebar,
} from './ProfileSidebar.styled'

export const ProfileSidebar = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const cobrandedUser = cobrandingLogic.useCobrandedUser()

  return (
    <SProfileSidebar className={className}>
      <Link href="/" passHref legacyBehavior>
        <SLogoAnchor>
          {cobrandedUser?.partnerImageUrl ? (
            <HStack
              css={css`
                svg:first-child {
                  width: 7.25rem;
                }
                svg:last-child {
                  width: 1.875rem;
                }
              `}
            >
              <LogoOfTheDay />
              <SLogoDivider />
              <CobrandedPartnerLogo logoUrl={cobrandedUser.partnerImageUrl} />
            </HStack>
          ) : (
            <LogoOfTheDay />
          )}
        </SLogoAnchor>
      </Link>
      <Stack
        css={css`
          justify-content: space-between;
          flex-grow: 1;
        `}
      >
        <Stack
          as="nav"
          space={20}
          css={css`
            align-items: flex-start;
            flex-grow: 1;
            padding-bottom: 1rem;
          `}
        >
          <NavigationDashboard component={<ProfileSidebarLink />} />
        </Stack>
        {cobrandedUser && (
          <Text variant="bodySmall" css={{ maxWidth: '12rem' }}>
            <Trans
              t={t}
              i18nKey="common.gt_experience_dashboard_navigation_cobranded"
              values={{
                partner: cobrandedUser.partnerDisplayName,
              }}
            />
          </Text>
        )}
      </Stack>
      <div css={{ minHeight: 'var(--p-spacing)' }} />
    </SProfileSidebar>
  )
}
